import { useNavigate } from '@tanstack/react-router';
import type { VisualizationType } from '@tempo-io/roadmap-dto';
import { Button } from '@tempo-io/sui-button';
import { Tune } from '@tempo-io/sui-icons';
import { useTranslation } from 'react-i18next';
import { useOrgName } from '@/lib/hooks/common/useOrgName';

export const VisualizationNoHeadersState = ({
  visualizationType,
}: {
  visualizationType: VisualizationType;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const org = useOrgName();
  return (
    <div className="flex flex-col  w-full items-center gap-4 py-8">
      <div className="text-xl font-bold">
        {t('views.visualization.emptyStates.noHeaders.title')}
      </div>

      {visualizationType === 'swimlane' && (
        <div className="text-lg">{t('views.swimlane.emptyStates.noHeaders.description')}</div>
      )}
      <div className="text-md text-text-neutral-secondary">
        {t('views.visualization.emptyStates.noHeaders.subtitle')}
      </div>
      <Button
        className="my-2 w-60"
        onClick={() => navigate({ to: '/org/$org/settings/custom-fields', params: { org } })}
      >
        <Tune /> {t('views.visualization.emptyStates.noHeaders.button')}
      </Button>
    </div>
  );
};
